import { ReceivedReviewsLoader } from "@/modules/performance/feedbacks/loader";
import { fetchReceivedReviews } from "@/modules/performance/team-performance/employee-reviews/api";
import React from "react";
import { useParams } from "react-router-dom";
import List from "components/list";
import { StatusCell } from "@/components/status/cell";
import { RenderProfile } from "components/render-profile";
import { useFetch } from "@/hooks/useFetch";
import ReviewsOfSection from "@/modules/performance/team-performance/employee-reviews/reviews-of";
import ButtonWithIcon from "@/components/button/icon";
import { AVERAGE } from "icons";
import { getUserFields } from "components/user/config";

const EmployeeReviews = () => {
  const { quadId, employeeId } = useParams();

  const { data, isLoading, isError } = useFetch({
    queryKey: ["received-reviews", quadId, employeeId],
    queryFn: () => fetchReceivedReviews({ quadId, employeeId }),
  });

  const fields = [
    "id",
    "quadrimester",
    "status",
    getUserFields("reviewer"),
    "self_nominated",
  ];

  if (isLoading) return <ReceivedReviewsLoader />;

  if (isError)
    return (
      <div className="text-center py-10">Error fetching received reviews</div>
    );

  const filters = {
    quadrimester: { _eq: quadId },
    reviewee: { _eq: employeeId },
    reviewer: { _neq: employeeId },
  };

  const columns = [
    {
      header: "Reviewer",
      accessorKey: "reviewer",
      cell: ({ getValue }) => <RenderProfile user={getValue()} />,
    },
    {
      header: "Type",
      accessorKey: "self_nominated",
      cell: ({ getValue }) => (getValue() ? "Nominated" : "System"),
    },
    {
      header: "Status",
      accessorKey: "status",
      cell: StatusCell,
    },
  ];

  return (
    <div className="flex-1">
      <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-2 gap-4 lg:m-6 m-4">
        <ReviewsOfSection />
      </div>
      <List
        title="Reviews"
        endPoint="performance_review"
        inlineFilters={true}
        storageKey={`performance_feedbacks-${quadId}-${employeeId}`}
        filters={filters}
        columns={columns}
        showSearch={false}
        renderFilters={() => (
          <ButtonWithIcon icon={AVERAGE} variant="outline" href="average">
            Average
          </ButtonWithIcon>
        )}
        // hidePagination={true}
        meta={{ fields }}
        href={(item) => (item.status === "pending" ? null : item.id)}
      />
    </div>
  );
};

export default EmployeeReviews;
